import type { IRoute } from './config'
import routes from './config'
export function flattenRoute(routeList: IRoute[], deep: boolean, auth: boolean): IRoute[] {
  const result: IRoute[] = []

  for (let i = 0; i < routeList.length; i += 1) {
    const route = routeList[i]

    result.push({
      ...route,
      auth: typeof route.auth !== 'undefined' ? route.auth : auth,
    })

    if (route.children && deep) {
      result.push(...flattenRoute(route.children, deep, auth))
    }
  }

  return result
}

function getLayoutRouteList(): IRoute[] {
  return flattenRoute(routes, false, false)
}

export const layoutRouteList = getLayoutRouteList()
